import React, { Component, useEffect, useState, useRef } from "react";
import { AgGridReact } from 'ag-grid-react';
import { useSelector, useDispatch } from "react-redux";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getUserData
} from "../redux/slices/homeSlice";

const Auth = localStorage.getItem("Auth");
const org = localStorage.getItem("org");
const access_token = localStorage.getItem("Auth");
const admin = localStorage.getItem("admin");

function ActionModel(props) {

  const dispatch = useDispatch();

  const [rowData, setRowData] = useState([]);
  const [updateFields, setUpdateFields] = useState({

  });


  useEffect(() => {
    // Use leads from props
    
    setRowData(props.bulkvalue);
  }, [props.bulkvalue]);

  

  const [selectedvalue, setSelectedValue] = useState('');
  const [selectedTicket, setSelectedTicket] = useState('');
  const [totalcount, setTotalCount] = useState(0);
  const [feed, setFeed] = useState([]);

  



  
  const columnDefs = [
  { headerName: "📌 Title", field: "title", filter: 'agTextColumnFilter' },
  { headerName: "🧑 Contact Person", field: "contactPerson", filter: 'agTextColumnFilter' },
  { headerName: "🗂️ Pipeline", field: "pipeline", filter: 'agTextColumnFilter' },
  { headerName: "📈 Status", field: "lead_status", filter: 'agTextColumnFilter' },
  { headerName: "👑 Owner", field: "owner", filter: 'agTextColumnFilter' },
  {
  headerName: "📞 Phone",
  field: "phone",
  filter: 'agTextColumnFilter',
  valueGetter: (params) => {
    const phones = params.data?.phone || [];
    return phones.join(", ");
  }
},
 {
  headerName: "📧 Email",
  field: "email",
  filter: 'agTextColumnFilter',
  valueGetter: (params) => {
    const email = params.data?.email || [];
    return email.join(", ");
  }
}
];
 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateFields((prev) => ({ ...prev, [name]: value }));
  };

  

const handleBulkUpdate = async () => {


  const LeadIds = rowData.map((node) => node.Id);
  const TicketIds = rowData.map((node) => node.TicketId);


  if (LeadIds.length === 0) {
    toast.warn('⚠️ Select at least one lead.', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    return;
  }

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${Auth}`,
  };

  try {
    const res = await axios.put(
      '/leads/bulk-update',
      {
        lead_ids: LeadIds,
        update_fields: updateFields,
        ticket_ids: TicketIds
      },
      { headers }
    );

    toast.success('Leads updated successfully!', {
      position: "top-right",
      toastId: 'bulk-update-success',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });

        // 👇 Refresh the page after a short delay to allow the toast to show
    setTimeout(() => {
      window.location.reload();
    }, 1000); // You can adjust this delay

  } catch (err) {
    console.error(err);
    toast.error('Failed to update leads. Try again.', {
      position: "top-right",
      toastId: 'bulk-update-failed',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }
};

  function bulkcopy(item){


    if(item == '1'){
    
        setSelectedValue(extractUniqueStringValues(props.bulkvalue, 'Id'));
        setTotalCount(props.bulkvalue.length);  
    
      }else if(item == '2'){
    
        setSelectedValue(extractUniqueValues(props.bulkvalue, 'email').toString());
        setTotalCount(props.bulkvalue.length);
    
      }else if(item == '3'){
    
        setSelectedValue(extractUniqueValues(props.bulkvalue, 'phone').toString());
        setTotalCount(props.bulkvalue.length);
    
      }

  }

  function fetchUserData() {
    dispatch(getUserData({ access_token, org })).then((res) => {
      if (res.payload.status == 200) {
        setFeed(res.payload.data);
      }
    });
    
  }




  function extractUniqueValues(data, keyword) {
    // Ensure the keyword is valid and data is an array
    if (!data || !Array.isArray(data) || !keyword) {
      console.error('Invalid input data or keyword');
      return [];
    }
  
    // Use a Set to store unique values
    const uniqueValuesSet = new Set();
  
    // Iterate through the array of objects
    data.forEach((item) => {
      // Check if the keyword exists in the current item and is an array
      if (item.hasOwnProperty(keyword) && Array.isArray(item[keyword])) {
        const values = item[keyword];
  
        // Add each element of the array to the set
        values.forEach((value) => {

            if (value !== '') {
                uniqueValuesSet.add(value);
            }
          
        });
      }
    });
  
    // Convert the Set to an array and return
    return Array.from(uniqueValuesSet);
  }
  
  function extractUniqueStringValues(data, keyword) {
  // Validate inputs
  if (!data || !Array.isArray(data) || !keyword) {
    console.error('Invalid input data or keyword');
    return [];
  }

  const uniqueValuesSet = new Set();

  data.forEach((item) => {
    // Check if the keyword exists and is a non-empty string
    if (item.hasOwnProperty(keyword)) {
      const value = item[keyword];

      if (typeof value === 'string' && value.trim() !== '') {
        uniqueValuesSet.add(value.trim());
      }
    }
  });

  return Array.from(uniqueValuesSet);
}

 
     useEffect(()=>{
        bulkcopy(props.actiontype);
     }, [])

     useEffect(() => {
         fetchUserData();
         
       }, [1]);
  return (
    <>{props.actiontype == '1'?<>
      <p>Total records: <b>{totalcount}</b></p>

    

  <p data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" style={{ cursor: "pointer" }}>
    <i className="bi bi-caret-down-fill"></i> Record ID List 
  </p>

<div class="collapse" id="collapseExample">

    
    <textarea
    className="form-control border border-dark"
    id="exampleFormControlTextarea1"
    rows={4}
    defaultValue={""}
    value={selectedvalue}
  />
  <br/>


</div>

 

    

   
      
      <div
      className="ag-theme-alpine"
      style={{ height: '500px', width: '100%' }}
    >
  <AgGridReact
    rowData={rowData}
    columnDefs={columnDefs}
    
    suppressRowClickSelection={true}
    suppressClipboardPaste={true}
    getRowId={(params) => params.data.TicketId?.toString()}
   enableFilter={true}
   pagination={true}
    paginationPageSize={10}
    animateRows={true}
   defaultColDef={{
  flex: 1,
  sortable: true,
  filter: true,
  resizable: true,
  floatingFilter: true,
}}
  />
</div>
     
     

<div className="mt-3">
        <h5><i className="bi bi-pencil-fill"></i> Update All Leads:</h5>
          
        <div className="row mb-3">
          {/* <div className="col-md-4  mb-2">
            <label className="form-label">Pipeline Stage</label>
            <input
              type="text"
              className="form-control form-control-sm"
              name="pipelineCurrentStage"
              value={updateFields.pipelineCurrentStage}
              onChange={handleInputChange}
              placeholder="e.g. Home Loan"
            />
          </div> */}

          <div className="col-md-4 mb-2">
            <label className="form-label">Priority: </label>
            <select
              name="priority"
              className="form-select form-select-sm"
              value={updateFields.priority}
              onChange={handleInputChange}
            >
               <option selected="">Priority</option>
  <option value="low">Low</option>
  <option value="medium">Medium</option>
  <option value="high">High</option>
            </select>
          </div>

          <div className="col-md-4 mb-2">
            <label className="form-label">Visible To: </label>
           <select
  className="form-select form-select-sm cursor"
  id="inputGroupSelect04"
  name="visibleTo"
  value={updateFields.visibleTo}
onChange={handleInputChange}
  aria-label="Example select with button addon"
><option selected="">Choose visible to</option>
<option value="Item owner">Item owner & admin </option>
<option value="All users">All users </option>
<option value="Only admin">Only admin </option>
                                      
  </select>
          </div>

          <div className="col-md-4 mb-2">
            <label className="form-label">Closing date: </label>
           <input
type="date"
name="expectedClosingDate"
class="form-control form-control-sm"
value={updateFields.expectedClosingDate}
onChange={handleInputChange}
placeholder="Expected closing date"
/>
          </div>

           <div className="col-md-4 mb-2">
            <label className="form-label">Description: </label>
           <textarea
    className="form-control"
    id="exampleFormControlTextarea1"
    name="Description"
    value={updateFields.Description}
    onChange={handleInputChange}
    rows={2}
    defaultValue={""}
  />
          </div>

         {admin === "true" &&<> <div className="col-md-4 mb-2">
            <label className="form-label">Owner: </label>
           <select
  className="form-select form-select-sm cursor"
  id="inputGroupSelect04"
  name="owner"
  value={updateFields.owner}
onChange={handleInputChange}
  aria-label="Example select with button addon">
    <option selected="">Choose owner</option>
    {feed &&
                                          feed?.map((item) => (
                                            <option
                                              value={
                                                item.user_name + "-" + item.id
                                              }
                                            >
                                              {item.user_name}-{item.role}
                                            </option>
                                          ))}

  </select>
          </div></>}


          <div className="col-md-4 mb-2">
            <label className="form-label">Add Collaboration: </label>
           <select
  className="form-select form-select-sm cursor"
  id="inputGroupSelect04"
  name="collaborator"
  value={updateFields.collaborator}
onChange={handleInputChange}
  aria-label="Example select with button addon">
    <option selected="">Choose collaborator</option>
    {feed &&
                                          feed?.map((item) => (
                                            <option
                                              value={
                                                item.user_name + "-" + item.id
                                              }
                                            >
                                              {item.user_name}-{item.role}
                                            </option>
                                          ))}

  </select>
          </div>

          <div className="col-md-4 mb-2">
            <label className="form-label">Remove Collaboration: </label>
           <select
  className="form-select form-select-sm cursor"
  id="inputGroupSelect04"
  name="removecollaborator"
  value={updateFields.removecollaborator}
onChange={handleInputChange}
  aria-label="Example select with button addon">
    <option selected="">Choose collaborator</option>
    {feed &&
                                          feed?.map((item) => (
                                            <option
                                              value={
                                                item.user_name + "-" + item.id
                                              }
                                            >
                                              {item.user_name}-{item.role}
                                            </option>
                                          ))}

  </select>
          </div>

          

          
        </div>
        <hr/>
        <h5><i className="bi bi-arrow-clockwise"></i> Changes:</h5>
        <div className="mb-3">
    {/* Show selected fields as removable tags */}
    {Object.entries(updateFields).map(([key, value]) => {
      return value ? (
        <span key={key} className="badge_multi me-2 mb-2">
          {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
          <i
            className="bi bi-x-circle-fill ms-2"
            style={{ cursor: "pointer" }}
            onClick={() =>
              setUpdateFields((prev) => ({ ...prev, [key]: '' }))
            }
          ></i>
        </span>
      ) : null;
    })}
  </div>

        <button
  className="btn btn-primary btn-sm"
  onClick={handleBulkUpdate}
  disabled={
    Object.values(updateFields).filter(Boolean).length === 0
  }
>
  Update Selected Leads
</button>
</div>

     
    
    </>:props.actiontype == '2'?<><div className="mb-3">
  <label htmlFor="exampleFormControlTextarea1" className="form-label">
  <i className="bi bi-envelope-paper-fill"></i> Copy Email List :
  </label>
  <textarea
    className="form-control border border-dark"
    id="exampleFormControlTextarea1"
    rows={4}
    defaultValue={""}
    value={selectedvalue}
  />
</div>
 </>:props.actiontype == '3'?<><div className="mb-3">
  <label htmlFor="exampleFormControlTextarea1" className="form-label">
   <i className="bi bi-phone-fill"></i> Copy Phone Number List : 
  </label>
  <textarea
    className="form-control border border-dark"
    id="exampleFormControlTextarea1"
    rows={4}
    defaultValue={""}
    value={selectedvalue}
  />
</div></>:null   }

<ToastContainer />
</>
  )
}

export default ActionModel